import { EntityType } from "constants/entities.enum";
import { createEntityState } from "entities/charts/factory";
import { createMergeWithDefaults } from "entities/utils";
import { EvaChartFeatures } from "types";

import { RIG_FRAC_ACTIVITY_FEATURES } from "./rigFracActivity";

// Feature set for both Well Status charts.
//
// Identical to the Rig/Frac bare-bones set — screenshot / fullscreen / legend /
// data table on, every wells-production concern off — with ONE difference:
// `chartFocus` is enabled. That is the existing wells Chart Focus feature, which
// the ticket asks for ("colours will be inherited from the focus bins or Chart
// focus (add that option in chart)"); with `show: true` the shared
// ChartFocusToggle renders in the widget toolbar and gives the group-by picker,
// bin settings and palette for free (research D9).
//
// Both charts share this set: the time-scale selector is wrapper-level and gated
// on chartType, not a feature, so there is nothing to differentiate.
const WELL_STATUS_FEATURES: Partial<EvaChartFeatures> = {
  ...RIG_FRAC_ACTIVITY_FEATURES,
  chartFocus: createEntityState(EntityType.ChartFocusFeature, {
    show: true,
    enabled: true,
    // Off by default: grouping and colours follow the GLOBAL focus until the
    // user opts into a chart-specific one.
    active: false
  })
};

export const wellStatusFeatures = createMergeWithDefaults(WELL_STATUS_FEATURES);
